import { DIMENSION_TITLES, MEASURE_TITLES } from '../analytics'
import { MEASURE_DEFINITION_BY_TITLE } from '../analyticsDefinitions'
import { EXPLORER_TYPE } from '../renderTypes'
import { OrderValue } from '~/types/cube'
import { SourceType } from '~/types/sources'
import { DashboardModuleType, type DashboardConfig } from '~/types/dashboards'

export const createSourcingDashboardConfig = (): DashboardConfig => {
  return [
    {
      titleKey: 'dashboard.sourcing.applicationMetrics',
      content: [
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.jobs.countHire.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_HIRE,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_COUNT_HIRE
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_HIRE]
            }
          }
        },
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey: 'dashboard.sourcing.newApplicationsBySource.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_APPLY,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.sourcing.newApplicationsBySource.info.definition',
                source: SourceType.ATS,
                insight:
                  'dashboard.sourcing.newApplicationsBySource.info.insight'
              }
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_APPLY],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE],
              order: [
                [MEASURE_TITLES.RECRUITMENT_COUNT_APPLY, OrderValue.DESC]
              ],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey: 'dashboard.sourcing.newApplicationsBySourceType.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_APPLY,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.sourcing.newApplicationsBySourceType.info.definition',
                source: SourceType.ATS,
                insight:
                  'dashboard.sourcing.newApplicationsBySourceType.info.insight'
              }
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_APPLY],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE],
              order: [
                [MEASURE_TITLES.RECRUITMENT_COUNT_APPLY, OrderValue.DESC]
              ],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.sourcing.countApply.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_APPLY,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_COUNT_APPLY
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_APPLY]
            }
          }
        },
        {
          moduleType: DashboardModuleType.SINGLE,
          options: {
            config: {
              titleKey: 'dashboard.sourcing.notContactedApplyRatio.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_NOT_CONTACTED_APPLY_RATIO,
                type: EXPLORER_TYPE.KPI
              },
              infoContent:
                MEASURE_DEFINITION_BY_TITLE[
                  MEASURE_TITLES.RECRUITMENT_NOT_CONTACTED_APPLY_RATIO
                ]
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_NOT_CONTACTED_APPLY_RATIO]
            }
          }
        }
      ]
    },
    {
      titleKey: 'dashboard.sourcing.additionalMetrics',
      content: [
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey:
                'dashboard.sourcing.globalAcceptanceRateBySourceType.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.sourcing.globalAcceptanceRateBySourceType.info.definition',
                source: SourceType.ATS,
                insight:
                  'dashboard.sourcing.globalAcceptanceRateBySourceType.info.insight'
              }
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE],
              order: [
                [
                  MEASURE_TITLES.RECRUITMENT_GLOBAL_ACCEPTANCE_RATE,
                  OrderValue.DESC
                ]
              ],
              limit: 5
            }
          }
        },
        {
          moduleType: DashboardModuleType.DISTRIBUTION,
          options: {
            config: {
              titleKey: 'dashboard.sourcing.newHiresBySourceType.title',
              exploreLink: {
                measure: MEASURE_TITLES.RECRUITMENT_COUNT_HIRE,
                dimension: DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE,
                type: EXPLORER_TYPE.DOUGHNUT
              },
              infoContent: {
                definition:
                  'dashboard.sourcing.newHiresBySourceType.info.definition',
                source: SourceType.ATS,
                insight: 'dashboard.sourcing.newHiresBySourceType.info.insight'
              }
            },
            query: {
              measures: [MEASURE_TITLES.RECRUITMENT_COUNT_HIRE],
              dimensions: [DIMENSION_TITLES.JOB_APPLICATION_HIRING_SOURCE_TYPE],
              order: [[MEASURE_TITLES.RECRUITMENT_COUNT_HIRE, OrderValue.DESC]],
              limit: 5
            }
          }
        }
      ]
    }
  ]
}
